import { MODAL_DISMISS, MODAL_OPEN } from '@engine/actions/action-types';
/**
 * Action Creators for Modal Dialog
 */

export var openModal = function openModal() {
  return {
    type: MODAL_OPEN
  };
};
export var modalDismiss = function modalDismiss() {
  return {
    type: MODAL_DISMISS
  };
};